export default "__VITE_ASSET__c272ebbd__"